import { accountAxiosInstance } from "@/services/axios";
import { VendorTimings } from "@/types/vendor/timings";

export const getVendorTimingsByVendorId = async (vendorId: string) => {
  const response = await accountAxiosInstance.get(`/vendor/timings/`, {
    params: {
      vendor_id: vendorId,
    },
  });
  return response.data;
};

export const createVendorTiming = async (data: VendorTimings) => {
  const response = await accountAxiosInstance.post("/vendor/timings/", data);
  return response.data;
};

export const updateVendorTimingById = async (
  id: string,
  data: VendorTimings,
) => {
  const response = await accountAxiosInstance.patch(
    `/vendor/timings/${id}/`,
    data,
  );
  return response.data;
};
